import { Chip } from '@mui/material';
import { AlertCmStatus } from '../../types/alerts';
import { pascalCase } from '../../utils/textUtils';

const cmStatusColors: Record<string, { main: string; bg: string }> = {
  [AlertCmStatus.QUEUED]: { main: '#3b82f6', bg: '#eff6ff' },
  [AlertCmStatus.ACTION_NEEDED]: { main: '#ef4444', bg: '#fef2f2' },
  [AlertCmStatus.AUTO_RESOLVED]: { main: '#58C492', bg: '#EAFBF3' },
  [AlertCmStatus.RESOLVED]: { main: '#58C492', bg: '#EAFBF3' },
};

interface AlertCmStatusChipProps {
  status: string;
}

export default function AlertCmStatusChip({ status }: AlertCmStatusChipProps) {
  const colors = cmStatusColors[status] || { main: '#6b7280', bg: '#f3f4f6' };
  return (
    <Chip
      label={pascalCase(status)}
      sx={{
        backgroundColor: colors.bg,
        color: colors.main,
        fontWeight: 500,
        borderRadius: '10px',
      }}
    />
  );
}
